import React from "react";
import {
  Grid,
  Box,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Typography,
} from "@mui/material";
import { Schedule as ScheduleIcon, CalendarToday } from "@mui/icons-material";
import dayjs from "dayjs";
import RunNow from "./RunNow"; // Reuse RunNow component for common fields

const RunLater = ({
  // All RunNow props
  platforms,
  contentType,
  mediaFile,
  postContent,
  selectedAccounts,
  socialMediaAccounts,
  loadingAccounts,
  onContentTypeChange,
  onPlatformChange,
  onAccountChange,
  onPostContentChange,
  onMediaUpload,
  onRemovePlatform,
  onRemoveAccount,
  onRemoveMediaFile,
  onRemoveAllMediaFiles,
  getAvailablePlatforms,
  getAvailableAccounts,

  // AI props
  onOpenAIChat,
  isBusinessPlan,

  // Template
  onOpenTemplate,

  // Marketing Assets
  onMarketingAssetSelect,

  // RunLater specific props
  dateTime,
  onOpenCalendar,
}) => {
  return (
    <>
      {/* Reuse all common fields from RunNow */}
      <RunNow
        platforms={platforms}
        contentType={contentType}
        mediaFile={mediaFile}
        postContent={postContent}
        selectedAccounts={selectedAccounts}
        socialMediaAccounts={socialMediaAccounts}
        loadingAccounts={loadingAccounts}
        onContentTypeChange={onContentTypeChange}
        onPlatformChange={onPlatformChange}
        onAccountChange={onAccountChange}
        onPostContentChange={onPostContentChange}
        onMediaUpload={onMediaUpload}
        onRemovePlatform={onRemovePlatform}
        onRemoveAccount={onRemoveAccount}
        onRemoveMediaFile={onRemoveMediaFile}
        onRemoveAllMediaFiles={onRemoveAllMediaFiles}
        getAvailablePlatforms={getAvailablePlatforms}
        getAvailableAccounts={getAvailableAccounts}
        onOpenAIChat={onOpenAIChat}
        isBusinessPlan={isBusinessPlan}
        onOpenTemplate={onOpenTemplate}
        onMarketingAssetSelect={onMarketingAssetSelect}
      />

      {/* Date Time Picker - RunLater specific */}
      <Grid item xs={12}>
        <Box sx={{ display: "flex", gap: 2, alignItems: "stretch" }}>
          <TextField
            label="Selected Date & Time"
            fullWidth
            value={
              dateTime ? dayjs(dateTime).format("MMMM DD, YYYY at HH:mm") : ""
            }
            disabled={
              !contentType ||
              platforms.length === 0 ||
              selectedAccounts.length === 0
            }
            InputProps={{
              readOnly: true,
            }}
            sx={{
              bgcolor: "#f8fafc",
              borderRadius: 2,
              "& .MuiOutlinedInput-root": { borderRadius: 2 },
            }}
            error={!dateTime}
            helperText={!dateTime ? "Please select date and time" : ""}
          />

          <Button
            variant="contained"
            onClick={onOpenCalendar}
            startIcon={<ScheduleIcon />}
            sx={{
              bgcolor: "#4B5AB6",
              fontWeight: 600,
              px: 3,
              py: 1.75,
              minWidth: "fit-content",
              whiteSpace: "nowrap",
              height: "56px",
              alignSelf: "flex-start",
              "&:hover": { bgcolor: "#3a4891" },
            }}
          >
            Select Date & Time
          </Button>
        </Box>

        <Typography
          variant="caption"
          sx={{
            display: "block",
            color: "#4B5AB6",
            fontWeight: 500,
            mt: 1,
            fontStyle: "italic",
          }}
        >
          💡 Click "Select Date & Time" to view existing scheduled posts and
          pick a date
        </Typography>
      </Grid>
    </>
  );
};

export default RunLater;
